import "./style.css";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import vertex from "./shaders/vertex.glsl";
import fragment from "./shaders/fragment.glsl";
import * as dat from "dat.gui";
import gsap from "gsap";

/**
 * Base
 */
// Debug
// const gui = new dat.GUI({closed: true})

// Canvas
const canvas = document.querySelector("canvas.webgl");

// Scene
const scene = new THREE.Scene();

/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader();


const matcapTexture1 = textureLoader.load("/textures/matcaps/18.png");
const matcapTexture2 = textureLoader.load("/textures/matcaps/5.png");

//  const matcapTexture = textureLoader.load('/image2.jpg')

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

/**
 * Object
 */
var geometry = new THREE.PlaneBufferGeometry(1, 1, 1, 1);

var material = new THREE.ShaderMaterial({
  vertexShader: vertex,
  fragmentShader: fragment,
  side: THREE.DoubleSide,
  uniforms: {
    uTime: { value: 0 },
    uMatcap1: { value: matcapTexture1 },
    uMatcap2: { value: matcapTexture2 },
    uResolution: { value: new THREE.Vector4() },
    uDisplaceFrequency: { value: 0.615 },
    uDisplaceSpeed: { value: 0.5 },
    uMouse: { value: new THREE.Vector2(0, 0) },
    uCamZPos: { value: 2 },
  },
});
// gui.add(material.uniforms.uDisplaceFrequency, "value").min(0).max(1).step(0.001).name("uDisplaceFrequency")
// gui.add(material.uniforms.uDisplaceSpeed, "value").min(0).max(1).step(0.001).name("uDisplaceSpeed")

const mesh = new THREE.Mesh(geometry, material);
scene.add(mesh);

/**
 * Media Query
 */
const smallMediaQuery = window.matchMedia("only screen and (max-width: 600px)");

if (smallMediaQuery.matches) {
  material.uniforms.uCamZPos.value = 4;
}

// smallMediaQuery.addEventListener('change', event => {
//    if (event.matches) {
//     material.uniforms.uCamZPos.value = 4

//    } else {
//     material.uniforms.uCamZPos.value = 2

//   }
//  })

/**
 * Raycaster
 */
// Image cover
const imageAspect = 1;
let a1;
let a2;
const raycaster = new THREE.Raycaster();

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

  if (sizes.height / sizes.width > imageAspect) {
    a1 = (sizes.width / sizes.height) * imageAspect;
    a2 = 1;
  } else {
    a1 = 1;
    a2 = (sizes.width / sizes.height) * imageAspect;
  }
  //Update uResolution
  material.uniforms.uResolution.value = new THREE.Vector4(sizes.width, sizes.height, a1, a2)
});



if (sizes.height / sizes.width > imageAspect) {
  a1 = (sizes.width / sizes.height) * imageAspect;
  a2 = 1;
} else {
  a1 = 1;
  a2 = (sizes.width / sizes.height) * imageAspect;
}
material.uniforms.uResolution.value = new THREE.Vector4(
  sizes.width,
  sizes.height,
  a1,
  a2
);

/**
 * Mouse Move Event
 */
const mouse = new THREE.Vector2();
window.addEventListener("mousemove", (e) => {
  mouse.x = e.clientX / sizes.width - 0.5;
  mouse.y = -(e.clientY / sizes.height) + 0.5;
});

/**
 * Camera
 */
// Base camera
const frustumSize = 1;
const camera = new THREE.OrthographicCamera(
  frustumSize / -2,
  frustumSize / 2,
  frustumSize / 2,
  frustumSize / -2,
  -1000,
  1000
);
camera.position.set(0, 0, 2);
scene.add(camera);

// Controls
// const controls = new OrbitControls(camera, canvas)
// controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
renderer.setClearColor(0xffffff);

/**
 * Animate
 */
const clock = new THREE.Clock();
let currentIntersect = null;

const tick = () => {
  const elapsedTime = clock.getElapsedTime();

  // Upadte uTime Uniform
  material.uniforms.uTime.value = elapsedTime;

  // Upadte uMouse Uniform
  material.uniforms.uMouse.value = mouse;

  // // Cast a Ray
  // raycaster.setFromCamera(mouse, camera)

  // const intersects = raycaster.intersectObject(mesh)

  //     // mesh.scale.set(1)
  //     // intersects.mesh.scale.set(3)

  // if (intersects.length) {
  //     if (currentIntersect === null) {
  //         console.log("Mouse enter")
  //     }

  //     currentIntersect = intersects[0]
  // } else {
  //     if (currentIntersect) {
  //         console.log("Mouse leave")
  //     }

  //     currentIntersect = null
  // }

  // Update controls
  // controls.update()

  // Render
  renderer.render(scene, camera);

  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
};

tick();
